export default __webpack_public_path__ + "static/media/icon_error400.bedd4184.svg";